import Breadcrumb from "../../component/Breadcrumb"

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Education App Development",
      slug:""
    },
  ]
}

export default function EducationBanner() {
  return (
    <>
      <section className="custom-app-banner ecom-banner header-gap">
        <div className="custom-banner-img">
          <img src="./assets/home/ecom-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <label>AI-Powered</label>
          <h1 className="heading center-heading"><span>Education App </span> 
          Development Company</h1>
          <p className="sub-heading">Empowering education through technology, we specialize in creating innovative and tailored education apps that drive impactful learning experiences, whether for schools, universities, or corporate training programs.</p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Breadcrumb breadcrumbData={breadcrumbData}/>
        </div>
      </section>
    </>
  )
}
